import React, { Component } from "react";
import {
  NormalTable,
  NormalSelect,
  NormalCheckbox,
  NormalInput,
  NormalButtonBackend,
} from "component/common";
import "./style.scss";
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";
import { withTranslation } from "react-i18next";
import {
  Paytables,
  NewPaytables,
  PayGroups,
  updateCommon,
} from "redux/actions/Backend";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Toast } from "service/toast";

export class PaymentTypeClass extends Component {
  state = {
    CommissionDetails: [
      { label: "Pay Code" },
      { label: "Payment Description" },
      { label: "Pay Group" },
      { label: "Sequence", divClass: "justify-content-end" },
      { label: "Active" },
    ],
    count: 10,
    isoption: false,
    iscreation: false,
    islist: false,
    List: [],
    code: null,
    desc: null,
    acc_code: null,
    gt_code: null,
    seq: null,
    creditcardcharges: 0,
    payment_charge: 0,
    bank_charges: null,
    bank_charges_amnt1: null,
    bank_charges_amnt2: null,
    bank_charges_amount1: null,
    bank_charges_amount2: null,
    bank_charges_amnt3: null,
    bank_charges_amount3: null,
    bank_charges_amount4: null,
    bank_charges_amnt4: null,
    gst: false,
    checked: true,
    credit_card: false,
    online_payment: false,
    payId: null,
    isbankcharge: false,

    option: [
      { value: "GT1", label: "GT1" },
      { value: "GT2", label: "GT2" },
    ],
    pay: [],
    pay_group: null,
    edit: false,
  };

  componentDidMount = () => {
    this.Listofpaytables({});
    this.Listofpaygroups({});
  };

  updateState = (data) => {
    if (this.state.isMounted) this.setState(data);
  };

  Listofpaytables = async () => {
    this.updateState({ is_loading: true });
    await this.props.Paytables().then((res) => {
      let { List } = this.state;
      List = res;
      console.log(List, "List");
      this.setState({
        List,
        is_loading: false,
      });
      console.log(List.length);
    });
  };

  Listofpaygroups = async () => {
    let { pay } = this.state;
    await this.props.PayGroups().then((res) => {
      console.log(res);

      for (let key of res) {
        pay.push({
          value: key.payGroupCode,
          label: key.payGroupCode,
          id: key.id,
        });
      }
      console.log(pay);
      this.setState({
        pay,
      });
      console.log(pay.length);
    });
  };

  generalcontent() {
    this.setState({
      iscreation: !this.state.iscreation,
    });
  }

  commissioncontent() {
    this.setState({
      islist: !this.state.islist,
    });
  }

  temp = ({ target: { value, name } }) => {
    let {
      code,
      desc,
      count,
      acc_code,
      gt_code,
      seq,
      creditcardcharges,
      payment_charge,
      bank_charges,
      bank_charges_amnt1,
      bank_charges_amnt2,
      bank_charges_amount1,
      bank_charges_amount2,
      bank_charges_amnt3,
      bank_charges_amount3,
      bank_charges_amount4,
      bank_charges_amnt4,
      gst,
      checked,
      credit_card,
      online_payment,
      isbankcharge,
      pay_group,
    } = this.state;
    if (name == "code") {
      code = value;
      this.setState({ code });
    }
    if (name == "desc") {
      desc = value;
      this.setState({ desc });
    }
    if (name == "acc_code") {
      acc_code = value;
      this.setState({ acc_code });
    }
    if (name == "gt_code") {
      gt_code = value;
      this.setState({ gt_code });
    }
    if (name == "seq") {
      seq = value;
      this.setState({ seq });
    }
    if (name == "creditcardcharges") {
      creditcardcharges = value;
      this.setState({ creditcardcharges });
    }
    if (name == "payment_charge") {
      payment_charge = value;
      this.setState({ payment_charge });
    }
    if (name == "bank_charges") {
      const regex = /^\d{1,6}(\.\d{1,3})?$/;
      if (regex.test(value) || value === "") {
        bank_charges = value;
        this.setState({ bank_charges });
      } else {
        window.alert("Maximum Number limit with up to 6 decimal...!");
      }
    }
    if (name == "bank_charges_amnt1") {
      const regex = /^\d{1,6}(\.\d{1,3})?$/;
      if (regex.test(value) || value === "") {
        bank_charges_amnt1 = value;
        this.setState({ bank_charges_amnt1 });
      } else {
        window.alert("Maximum Number limit with up to 6 decimal...!");
      }
    }
    if (name == "bank_charges_amnt2") {
      const regex = /^\d{1,6}(\.\d{1,3})?$/;
      if (regex.test(value) || value === "") {
        bank_charges_amnt2 = value;
        this.setState({ bank_charges_amnt2 });
      } else {
        window.alert("Maximum Number limit with up to 6 decimal...!");
      }
    }
    if (name == "bank_charges_amount1") {
      const regex = /^\d{1,6}(\.\d{1,3})?$/;
      if (regex.test(value) || value === "") {
        bank_charges_amount1 = value;
        this.setState({ bank_charges_amount1 });
      } else {
        window.alert("Maximum Number limit with up to 6 decimal...!");
      }
    }
    if (name == "bank_charges_amount2") {
      const regex = /^\d{1,6}(\.\d{1,3})?$/;
      if (regex.test(value) || value === "") {
        bank_charges_amount2 = value;
        this.setState({ bank_charges_amount2 });
      } else {
        window.alert("Maximum Number limit with up to 6 decimal...!");
      }
    }
    if (name == "bank_charges_amnt3") {
      const regex = /^\d{1,6}(\.\d{1,3})?$/;
      if (regex.test(value) || value === "") {
        bank_charges_amnt3 = value;
        this.setState({ bank_charges_amnt3 });
      } else {
        window.alert("Maximum Number limit with up to 6 decimal...!");
      }
    }
    if (name == "bank_charges_amount3") {
      const regex = /^\d{1,6}(\.\d{1,3})?$/;
      if (regex.test(value) || value === "") {
        bank_charges_amount3 = value;
        this.setState({ bank_charges_amount3 });
      } else {
        window.alert("Maximum Number limit with up to 6 decimal...!");
      }
    }
    if (name == "bank_charges_amount4") {
      const regex = /^\d{1,6}(\.\d{1,3})?$/;
      if (regex.test(value) || value === "") {
        bank_charges_amount4 = value;
        this.setState({ bank_charges_amount4 });
      } else {
        window.alert("Maximum Number limit with up to 6 decimal...!");
      }
    }

    if (name == "bank_charges_amnt4") {
      const regex = /^\d{1,6}(\.\d{1,3})?$/;
      if (regex.test(value) || value === "") {
        bank_charges_amnt4 = value;
        this.setState({ bank_charges_amnt4 });
      } else {
        window.alert("Maximum Number limit with up to 6 decimal...!");
      }
    }

    if (name == "gst") {
      gst = value;
      this.setState({ gst });
    }
    if (name == "pay_group") {
      pay_group = value;
      this.setState({ pay_group });
    }
    if (name == "checked") {
      checked = value;
      this.setState({ checked });
    }
    if (name == "credit_card") {
      credit_card = value;
      this.setState({ credit_card });
    }
    if (name == "online_payment") {
      online_payment = value;
      this.setState({ online_payment });
    }
    if (name == "isbankcharge") {
      isbankcharge = value;
      this.setState({ isbankcharge });
    }
  };
  handleEdit = async (itemcode) => {
    let {
      code,
      desc,
      count,
      acc_code,
      gt_code,
      seq,
      creditcardcharges,
      payment_charge,
      bank_charges,
      bank_charges_amnt1,
      bank_charges_amnt2,
      bank_charges_amount1,
      bank_charges_amount2,
      bank_charges_amnt3,
      bank_charges_amount3,
      bank_charges_amount4,
      bank_charges_amnt4,
      gst,
      checked,
      credit_card,
      online_payment,
      isbankcharge,
      pay_group,
      edit,
      temp,
      payId,
    } = this.state;
    edit = true;
    this.setState({ edit });
    console.log(edit, "edit");
    await this.props.Paytables().then((res) => {
      console.log(res, "res");

      let objIndex = res.findIndex((obj) => obj.payCode === itemcode);
      temp = res[objIndex];
      console.log(temp, "temp");
      this.setState({
        temp,
      });
      code = temp.payCode;
      desc = temp.payDescription;
      acc_code = temp.accountCode;
      gt_code = temp.gtGroup;
      seq = temp.sequence;
      creditcardcharges = temp.creditcardcharges;
      payment_charge = temp.onlinepaymentcharges;
      bank_charges = temp.bankCharges;
      bank_charges_amnt1 = temp.bankchargesamount0;
      bank_charges_amnt2 = temp.bankchargesamount10;
      bank_charges_amount1 = temp.bankchargesamount0adnlcharge;
      bank_charges_amount2 = temp.bankchargesamount10adnlcharge;
      bank_charges_amnt3 = temp.bankchargesamount100;
      bank_charges_amount3 = temp.bankchargesamount100adnlcharge;
      bank_charges_amount4 = temp.bankchargesamount1000adnlcharge;
      bank_charges_amnt4 = temp.bankchargesamount1000;
      gst = temp.payIsGst;
      checked = temp.payIsactive;
      credit_card = temp.iscreditcard;
      online_payment = temp.isonlinepayment;
      pay_group = temp.payGroup;
      payId = temp.payId;
      this.setState({
        code,
        desc,
        credit_card,
        online_payment,
        pay_group,
        payment_charge,
        gt_code,
        seq,
        creditcardcharges,
        bank_charges,
        bank_charges_amnt1,
        bank_charges_amnt2,
        bank_charges_amount1,
        bank_charges_amount2,
        bank_charges_amnt3,
        bank_charges_amount3,
        bank_charges_amount4,
        bank_charges_amnt4,
        gst,
        checked,
        acc_code,
        payId,
      });
    });
    this.setState({
      iscreation: true,
    });
  };

  Addnewone = async () => {
    let {
      code,
      desc,
      count,
      acc_code,
      gt_code,
      seq,
      creditcardcharges,
      payment_charge,
      bank_charges,
      bank_charges_amnt1,
      bank_charges_amnt2,
      bank_charges_amount1,
      bank_charges_amount2,
      bank_charges_amnt3,
      bank_charges_amount3,
      bank_charges_amount4,
      bank_charges_amnt4,
      gst,
      checked,
      isbankcharge,
      credit_card,
      online_payment,
      pay_group,
      payId,
      pay,
    } = this.state;
    if (code == null || desc == null || pay_group == null) {
      Toast({
        type: "error",
        message: "Please check required ",
      });
    } else {
      let payGroupId = pay.find((list) => list.value === pay_group);
      let newroom = {
        payCode: code,
        payDescription: desc,
        payGroup: pay_group,
        // payId: payId,
        payIsactive: checked,
        gtGroup: gt_code,
        rwUsebp: true,
        iscomm: true,
        sequence: seq,
        bankCharges: bank_charges,
        bankchargesamount0: bank_charges_amnt1,
        bankchargesamount10: bank_charges_amnt2,
        bankchargesamount0adnlcharge: bank_charges_amount1,
        bankchargesamount10adnlcharge: bank_charges_amount2,
        bankchargesamount100: bank_charges_amnt3,
        bankchargesamount100adnlcharge: bank_charges_amount3,
        bankchargesamount1000adnlcharge: bank_charges_amount4,
        bankchargesamount1000: bank_charges_amnt4,
        eps: 0,
        voucherPaymentControl: true,
        showInReport: true,
        payIsGst: gst,
        creditcardcharges: creditcardcharges,
        onlinepaymentcharges: payment_charge,
        iscreditcard: credit_card,
        isonlinepayment: online_payment,
        accountCode: acc_code,
        accountMapping: true,
        openCashdrawer: true,
        iscustapptpromo: true,
        payGroupIdId: payGroupId?.id,
        isvoucherExtvoucher: true,
      };
      await this.props
        .NewPaytables(newroom)
        .then((data) => {
          this.Listofpaytables({});
          Toast({
            type: "success",
            message: "Added Successfully",
          });
          //code = "";
          //count = "";
          code = "";
          desc = "";
          count = "";
          acc_code = "";
          gt_code = "";
          seq = "";
          creditcardcharges = "";
          payment_charge = "";
          bank_charges = "";
          bank_charges_amnt1 = "";
          bank_charges_amnt2 = "";
          bank_charges_amount1 = "";
          bank_charges_amount2 = "";
          bank_charges_amnt3 = "";
          bank_charges_amount3 = "";
          bank_charges_amount4 = "";
          bank_charges_amnt4 = "";
          gst = false;
          checked = true;
          isbankcharge = false;
          credit_card = false;
          online_payment = false;
          pay_group = "";
          this.setState({
            code,
            desc,
            count,
            acc_code,
            gt_code,
            seq,
            creditcardcharges,
            payment_charge,
            bank_charges,
            bank_charges_amnt1,
            bank_charges_amnt2,
            bank_charges_amount1,
            bank_charges_amount2,
            bank_charges_amnt3,
            bank_charges_amount3,
            bank_charges_amount4,
            bank_charges_amnt4,
            gst,
            checked,
            isbankcharge,
            credit_card,
            online_payment,
            pay_group,
          });
        })
        .catch((e) => console.log(e));
    }
  };
  handleUpdate = async () => {
    let {
      code,
      desc,
      count,
      acc_code,
      gt_code,
      seq,
      creditcardcharges,
      payment_charge,
      bank_charges,
      bank_charges_amnt1,
      bank_charges_amnt2,
      bank_charges_amount1,
      bank_charges_amount2,
      bank_charges_amnt3,
      bank_charges_amount3,
      bank_charges_amount4,
      bank_charges_amnt4,
      gst,
      checked,
      isbankcharge,
      credit_card,
      online_payment,
      pay_group,
      payId,
      pay,
    } = this.state;
    let payGroupId = pay.find((list) => list.value === pay_group);
    let newroom = {
      payCode: code,
      payDescription: desc,
      payGroup: pay_group,
      payIsactive: checked,
      gtGroup: gt_code,
      sequence: seq,
      bankCharges: bank_charges,
      bankchargesamount0: bank_charges_amnt1,
      bankchargesamount10: bank_charges_amnt2,
      bankchargesamount0adnlcharge: bank_charges_amount1,
      bankchargesamount10adnlcharge: bank_charges_amount2,
      bankchargesamount100: bank_charges_amnt3,
      bankchargesamount100adnlcharge: bank_charges_amount3,
      bankchargesamount1000adnlcharge: bank_charges_amount4,
      bankchargesamount1000: bank_charges_amnt4,
      payIsGst: gst,
      creditcardcharges: creditcardcharges,
      onlinepaymentcharges: payment_charge,
      iscreditcard: credit_card,
      isonlinepayment: online_payment,
      accountCode: acc_code,
      payGroupIdId: payGroupId?.id,
      payId: payId,
    };
    console.log(newroom, "NewRoom");
    await this.props
      .updateCommon(
        `Paytables/update?where=%7B%22payId%22%3A%20%22${payId}%22%7D
    `,
        newroom
      )
      .then((data) => {
        this.Listofpaytables({});
        Toast({
          type: "success",
          message: "Updated Successfully",
        });
      });
    //code = "";
    //count = "";
    code = "";
    desc = "";
    count = "";
    acc_code = "";
    gt_code = "";
    seq = "";
    creditcardcharges = "";
    payment_charge = "";
    bank_charges = "";
    bank_charges_amnt1 = "";
    bank_charges_amnt2 = "";
    bank_charges_amount1 = "";
    bank_charges_amount2 = "";
    bank_charges_amnt3 = "";
    bank_charges_amount3 = "";
    bank_charges_amount4 = "";
    bank_charges_amnt4 = "";
    gst = false;
    checked = true;
    isbankcharge = false;
    credit_card = false;
    online_payment = false;
    pay_group = "";
    this.setState({
      code,
      count,
      acc_code,
      gt_code,
      seq,
      creditcardcharges,
      payment_charge,
      bank_charges,
      bank_charges_amnt1,
      bank_charges_amnt2,
      bank_charges_amount1,
      bank_charges_amount2,
      bank_charges_amnt3,
      bank_charges_amount3,
      bank_charges_amount4,
      bank_charges_amnt4,
      gst,
      checked,
      isbankcharge,
      credit_card,
      online_payment,
      pay_group,
      desc,
    });

    this.generalcontent();
  };
  render() {
    let {
      online_payment,
      CommissionDetails,
      pageMeta,
      List,
      is_loading,
      code,
      desc,
      iscreation,
      islist,
      option,
      count,
      acc_code,
      gt_code,
      seq,
      creditcardcharges,
      payment_charge,
      bank_charges,
      bank_charges_amnt1,
      bank_charges_amnt2,
      bank_charges_amount1,
      bank_charges_amount2,
      bank_charges_amnt3,
      bank_charges_amount3,
      bank_charges_amount4,
      bank_charges_amnt4,
      gst,
      checked,
      pay,
      edit,
      pay_group,
      credit_card,
    } = this.state;
    let { t } = this.props;
    return (
      <>
        <div className="container-fluid salespayment bg-white">
          <div className="row">
            <div className="col-12">
              <h4 className="mt-3 label-head text-center text-md-left">
                {t("Payment Type")}
              </h4>
            </div>
          </div>

          <div
            className="d-flex  justify-content-between p-3 payment"
            onClick={() => this.generalcontent()}
          >
            <p>{t("Payment Type Creation")}</p>
            <div className="icons">
              {iscreation == false ? <AiOutlinePlus /> : <AiOutlineMinus />}
            </div>
          </div>
          {iscreation == true ? (
            <div className="container-fluid roomcontent">
              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="mt-4">
                    <p>
                      {t("Payment Code")}
                      <span style={{ color: "red" }}>*</span>
                    </p>
                    <div className="input-group">
                      <NormalInput
                        value={code}
                        name="code"
                        onChange={this.temp}
                      />
                    </div>
                  </div>
                  <div className="mt-3">
                    <span>{t("Payment Desc")}</span>
                    <span style={{ color: "red" }}>*</span>
                    <div className="input-group">
                      <NormalInput
                        value={desc}
                        name="desc"
                        onChange={this.temp}
                      />
                    </div>
                  </div>
                  <div className="mt-3">
                    <span>{t("Pay Group")}</span>
                    <span style={{ color: "red" }}>*</span>
                    <div className="input-group">
                      <NormalSelect
                        options={pay}
                        value={pay_group}
                        onChange={this.temp}
                        name="pay_group"
                      />
                    </div>
                  </div>
                  <div className="mt-3">
                    <p>{t("Account Code")}</p>
                    <div className="input-group">
                      <NormalInput
                        value={acc_code}
                        name="acc_code"
                        onChange={this.temp}
                      />
                    </div>
                  </div>
                  <div className="mt-3">
                    <p>{t("GT GROUP")}</p>
                    <div className="input-group">
                      <NormalSelect
                        options={option}
                        value={gt_code}
                        onChange={this.temp}
                        name="gt_code"
                      />
                    </div>
                  </div>
                  <div className="mt-3">
                    <p>{t("Sequence")}</p>
                    <div className="input-group">
                      <NormalInput
                        value={seq}
                        name="seq"
                        onChange={this.temp}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-6">
                  <div className="mt-5">
                    <div className="d-flex col-12 p-0 input-group">
                      <div className="col-7 d-flex p-0">
                        <NormalCheckbox
                          checked={credit_card}
                          name="credit_card"
                          onChange={this.temp}
                        />
                        <p>{t("Credit Card Charges")}</p>
                      </div>
                      <div className="col-5 d-flex p-0">
                        <NormalInput
                          value={creditcardcharges}
                          name="creditcardcharges"
                          onChange={this.temp}
                          type="number"
                        />
                        <p className="ml-1">(%)</p>
                      </div>
                    </div>
                  </div>
                  <div className="mt-3">
                    <div className="d-flex col-12 p-0 input-group">
                      <div className="col-7 d-flex p-0">
                        <NormalCheckbox
                          checked={online_payment}
                          name="online_payment"
                          onChange={this.temp}
                        />
                        <p>{t("Online Payment Charges")}</p>
                      </div>
                      <div className="col-5 d-flex p-0">
                        <NormalInput
                          value={payment_charge}
                          name="payment_charge"
                          onChange={this.temp}
                          type="number"
                        />
                        <p className="ml-1">(%)</p>
                      </div>
                    </div>
                  </div>
                  <div className="mt-3">
                    <div className="d-flex col-12 p-0 input-group">
                      <div className="col-7 d-flex p-0">
                        <p>{t("Bank Charges")}</p>
                      </div>
                      <div className="col-5 d-flex p-0">
                        <NormalInput
                          value={bank_charges}
                          name="bank_charges"
                          onChange={this.temp}
                          type="number"
                        />
                        <p className="ml-1">(%)</p>
                      </div>
                    </div>
                  </div>
                  <div className="mt-3">
                    <div className="d-flex col-12 p-0 input-group">
                      <div className="col-4 d-flex p-0">
                        <p>{t("Bank Charges Amount 0")}</p>
                      </div>
                      <div className="col-3 d-flex p-0">
                        <NormalInput
                          value={bank_charges_amnt1}
                          name="bank_charges_amnt1"
                          onChange={this.temp}
                          type="number"
                          placeholder="Amount 0"
                        />
                      </div>
                      <div className="col-1 d-flex p-0">
                        <p className="mt-2 pl-3">%</p>
                      </div>
                      <div className="col-3 d-flex p-0">
                        <NormalInput
                          value={bank_charges_amount1}
                          name="bank_charges_amount1"
                          onChange={this.temp}
                          type="number"
                          placeholder="Amount 0"
                        />
                      </div>
                      <div className="col-1 d-flex p-0">
                        <p className="mt-2 pl-3">$</p>
                      </div>
                    </div>
                  </div>
                  <div className="mt-3">
                    <div className="d-flex col-12 p-0 input-group">
                      <div className="col-4 d-flex p-0">
                        <p>{t("Bank Charges Amount 10")}</p>
                      </div>
                      <div className="col-3 d-flex p-0">
                        <NormalInput
                          value={bank_charges_amnt2}
                          name="bank_charges_amnt2"
                          onChange={this.temp}
                          type="number"
                          placeholder="Amount 10"
                        />
                      </div>
                      <div className="col-1 d-flex p-0">
                        <p className="mt-2 pl-3">%</p>
                      </div>
                      <div className="col-3 d-flex p-0">
                        <NormalInput
                          value={bank_charges_amount2}
                          name="bank_charges_amount2"
                          onChange={this.temp}
                          type="number"
                          placeholder="Amount 10"
                        />
                      </div>
                      <div className="col-1 d-flex p-0">
                        <p className="mt-2 pl-3">$</p>
                      </div>
                    </div>
                  </div>
                  <div className="mt-3">
                    <div className="d-flex col-12 p-0 input-group">
                      <div className="col-4 d-flex p-0">
                        <p>{t("Bank Charges Amount 100")}</p>
                      </div>
                      <div className="col-3 d-flex p-0">
                        <NormalInput
                          value={bank_charges_amnt3}
                          name="bank_charges_amnt3"
                          onChange={this.temp}
                          type="number"
                          placeholder="Amount 100"
                        />
                      </div>
                      <div className="col-1 d-flex p-0">
                        <p className="mt-2 pl-3">%</p>
                      </div>
                      <div className="col-3 d-flex p-0">
                        <NormalInput
                          value={bank_charges_amount3}
                          name="bank_charges_amount3"
                          onChange={this.temp}
                          type="number"
                          placeholder="Amount 100"
                        />
                      </div>
                      <div className="col-1 d-flex p-0">
                        <p className="mt-2 pl-3">$</p>
                      </div>
                    </div>
                  </div>
                  <div className="mt-3">
                    <div className="d-flex col-12 p-0 input-group">
                      <div className="col-4 d-flex p-0">
                        <p>{t("Bank Charges Amount 1000")}</p>
                      </div>
                      <div className="col-3 d-flex p-0">
                        <NormalInput
                          value={bank_charges_amnt4}
                          name="bank_charges_amnt4"
                          onChange={this.temp}
                          type="number"
                          placeholder="Amount 1000"
                        />
                      </div>
                      <div className="col-1 d-flex p-0">
                        <p className="mt-2 pl-3">%</p>
                      </div>
                      <div className="col-3 d-flex p-0">
                        <NormalInput
                          value={bank_charges_amount4}
                          name="bank_charges_amount4"
                          onChange={this.temp}
                          type="number"
                          placeholder="Amount 1000"
                        />
                      </div>
                      <div className="col-1 d-flex p-0">
                        <p className="mt-2 pl-3">$</p>
                      </div>
                    </div>
                  </div>
                  <div className="mt-3">
                    <div className="d-md-flex col-12 p-0">
                      <div className="mt-3 col-5 d-flex p-0">
                        <NormalCheckbox
                          checked={gst}
                          name="gst"
                          onChange={this.temp}
                        />
                        <p>{t("GST Active")}</p>
                      </div>
                      <div className="mt-3 d-flex input-group">
                        <NormalCheckbox
                          checked={checked}
                          name="checked"
                          onChange={this.temp}
                        />
                        <p>{t(" Active")}</p>
                      </div>
                    </div>
                  </div>
                </div>
                {!edit ? (
                  <div className="mt-4 col-12 col-md-3">
                    <NormalButtonBackend
                      mainbg={true}
                      label={"Add"}
                      onClick={() => this.Addnewone()}
                    />
                  </div>
                ) : (
                  <div className="mt-4 col-12 col-md-3">
                    <NormalButtonBackend
                      mainbg={true}
                      label={"Update"}
                      onClick={() => this.handleUpdate()}
                    />
                  </div>
                )}
              </div>
            </div>
          ) : (
            ""
          )}

          <div
            className="d-flex  justify-content-between p-3 payment mt-5"
            onClick={() => this.commissioncontent()}
          >
            <p>{t("Payment Type List")}</p>
            <div className="icons">
              {islist == false ? <AiOutlinePlus /> : <AiOutlineMinus />}
            </div>
          </div>
          {islist == true ? (
            <div>
              <div className="col-12 mt-1">
                <div className="tab-table-content">
                  <h5 className="mt-3 label-head text-center text-md-left">
                    {t("List of Payment Type")}
                  </h5>
                  <div className="py-4">
                    <div className="table-container">
                      <NormalTable headerDetails={CommissionDetails}>
                        {is_loading ? (
                          <tr>
                            <td colSpan="7">
                              <div class="d-flex mt-5 align-items-center justify-content-center">
                                <div class="spinner-border" role="status">
                                  <span class="sr-only">Loading...</span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ) : List.length > 0 ? (
                          List.map(
                            (
                              {
                                payCode,
                                payDescription,
                                payGroup,
                                sequence,
                                payIsactive,
                              },
                              index
                            ) => {
                              return (
                                <tr key={index}>
                                  <td>
                                    <div
                                      className="text-left cursor-pointer text-primary"
                                      onClick={() => this.handleEdit(payCode)}
                                    >
                                      {payCode}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="text-left">
                                      {payDescription}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="text-left">{payGroup}</div>
                                  </td>
                                  <td>
                                    <div className="text-left">{sequence}</div>
                                  </td>
                                  <td>
                                    <div className="text-left">
                                      {payIsactive == true ? "Yes" : "No"}
                                    </div>
                                  </td>
                                </tr>
                              );
                            }
                          )
                        ) : null}
                      </NormalTable>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      Paytables,
      NewPaytables,
      PayGroups,
      updateCommon,
    },
    dispatch
  );
};

export const PaymentType = withTranslation()(
  connect(null, mapDispatchToProps)(PaymentTypeClass)
);
